import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const FourZeroThree = () => {
  const { t } = useTranslation();

  return (
    <Result
      status={403}
      title={'403'}
      subTitle={t('403.description')}
      extra={
        <Link to={'/front'}>
          <Button type='primary'>{t('403.backToDashboard')}</Button>
        </Link>
      }
    />
  );
};
